import * as React from 'react';
import * as styles from './CarouselContentElement.css';
import { IUser } from '../../../interfaces/IUser';
import { ILike } from '../../../interfaces/ILike';
import { Helper } from '../../../Helper';
import { IALikes } from '../../likes/Likes';
import { IAComments } from '../../comments/Comments';
import { IAIcon } from '../../icon/Icon';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAUniqueViews } from '../../uniqueViews/UniqueViews';
import { IMessageCategory } from '../../../interfaces/IMessage';
import { IAMessageCategories } from '../../viewer/categories/MessageCategories';
import { IFontSlots } from '../../../interfaces/IFontSlots';
import Moment from 'react-moment';

export interface IProps {
  selected?: boolean;
  user?: IUser;
  author?: IUser;
  id?: string;
  tenant?: string;
  component?: string;
  instance?: string;
  token?: string;
  source?: string;
  index?: number;
  item?: any;
  environment?: "Development" | "Test" | "Production";
  resultSourceId?: string;
  siteCollection?: string;
  listName?: string;
  title?: string;
  image?: string;
  teaser?: string;
  videoUrl?: string;
  categories?: IMessageCategory[];
  showSkeleton?: boolean;
  likesEnabled?: boolean;
  commentsEnabled?: boolean;
  modifiedDate?: Date;
  backgroundColor?: string;
  borderColor?: string;
  highlightColor?: string;
  itemTitleColor?: string;
  itemTextColor?: string;
  itemTitleStyle?: string;
  itemTitleSize?: number;
  itemTitleAlign?: string;
  itemTitleWeight?: string;
  width?: number;
  likes?: ILike[];
  reactionOptions: string[];
  showEmojiPickerExpandButton: boolean;
  commentCount?: number;
  height: number;
  isMobile?: boolean;
  onMouseOver: (index: number) => void;
  onMouseLeave: (index: number) => void;
  onClickEdit?: (content: any) => void;
  onClickOpen?: () => void;
  onClickPreview?: (content: any) => void;
  onClickCopy?: (content: any) => void;
  onClickDelete?: (content: any) => void;
  likesUpdated?: (likes: ILike[]) => void;
  commentsUpdated?: (comments: number) => void;
  commentsClick?: () => void;
  showImage?: boolean;
  showTitle?: boolean;
  showCategories?: boolean;
  showTeaser?: boolean;
  showAuthor?: boolean;
  showStartDate?: boolean;
  showLikes?: boolean;
  showComments?: boolean;
  showDropShadow?: boolean;
  showCommandBarItems?: boolean;
  showUniqueViews?: boolean;
  uniqueViewsCount?: number;
  isMessageUnread?: boolean;
  unReadHighlight?: string;
  hasDarkBackground?: boolean;
  showPinIcon?: boolean;
  showLikesDimmed?: boolean;
  showCommentsDimmed?: boolean;
  showUniqueViewsDimmed?: boolean;
  fontSlots?: IFontSlots;
  userLocation?: string;
}

export interface IState {
  commandaBarOpen: boolean;
}

export class CarouselContentElement extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      commandaBarOpen: false
    };
  }


  public render(): JSX.Element {
    let commandBarItems: Array<any> = [];
    if (this.props.onClickEdit != undefined && !this.props.isMobile) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `edit-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickEdit(this.props.item)}
        >
          <IAIcon
            title="Edit"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Edit}
          </div>
        </div>
      );
    }
    if (this.props.onClickOpen != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `open-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickOpen()}
        >
          <IAIcon
            title="Open"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Open}
          </div>
        </div>
      );
    }
    if (this.props.onClickPreview != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `preview-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickPreview(this.props.item)}
        >
          <IAIcon
            title="Preview"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Preview}
          </div>
        </div>
      );
    }
    if (this.props.onClickCopy != undefined) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `copy-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickCopy(this.props.item)}
        >
          <IAIcon
            title="Copy"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Copy}
          </div>
        </div>
      );
    }

    if (this.props.onClickDelete != undefined && !this.props.isMobile) {
      commandBarItems.push(
        <div
          className={styles.IA_commandBarItem}
          key={this.props.id != undefined ? `delete-${this.props.id}` : Helper.getRandomStringKey()}
          onClick={() => this.props.onClickDelete(this.props.item)}
        >
          <IAIcon
            title="Close"
            size={14}
            color={"#333333"}
            style={{
              float: "left"
            }}
          />
          <div
            style={{
              color: "#333333",
              float: "left",
              marginLeft: 7
            }}
          >
            {new LocalizationService().strings.Card_CommandBar_Delete}
          </div>
        </div>
      );
    }
    let minHeight = 0;
    const likesShouldBeShown = this.props.likesEnabled && this.props.showLikes;
    const commentsShouldBeShown = this.props.commentsEnabled && this.props.showComments;

    let iconsAmount = 0;
    if (likesShouldBeShown) {
      iconsAmount++;
    }
    if (commentsShouldBeShown) {
      iconsAmount++;
    }
    if (this.props.showCommandBarItems) {
      iconsAmount++;
    }
    if (this.props.showUniqueViews) {
      iconsAmount++;
    }
    if (iconsAmount === 4) {
      minHeight = minHeight < 164 ? 164 : minHeight;
    }
    if (iconsAmount === 3) {
      minHeight = minHeight < 130 ? 130 : minHeight;
    }
    if (iconsAmount === 2) {
      minHeight = minHeight < 90 ? 90 : minHeight;
    }
    if (this.props.showCommandBarItems && minHeight < 122) {
      minHeight = 122;
    }
    let commandBarWidth = (!this.props.showSkeleton && this.props.showLikes || !this.props.showSkeleton && this.props.showComments || !this.props.showSkeleton && this.props.showUniqueViews || !this.props.showSkeleton && this.props.showCommandBarItems) ? 40 : 0;
    const hasCategories = !this.props.showSkeleton && this.props.showCategories && this.props.categories != undefined && this.props.categories.length > 0;
    return (
      <div
        className={styles.IA_carrouselContentElement}
        style={{
          height: this.props.height,
          color: this.props.itemTextColor,
          backgroundColor: this.props.backgroundColor?.length > 7 && this.props.backgroundColor.includes("#") ? this.props.backgroundColor.substring(0, 7) : this.props.backgroundColor,
          borderTop: this.props.borderColor && this.props.index !== 0 ? `1px solid ${this.props.borderColor}` : ''
        }}
        onMouseOver={() => this.props.onMouseOver(this.props.index)}
        onMouseLeave={() => this.props.onMouseLeave(this.props.index)}
      >
        {this.props.isMessageUnread && <div className={styles.IAUnread} style={{ borderLeft: `6px solid ${this.props.unReadHighlight ? this.props.unReadHighlight : "#ffb900"}` }}></div>}
        {this.props.selected &&
          <div
            className={styles.IA_arrow}
            style={{
              backgroundColor: this.props.backgroundColor?.length > 7 && this.props.backgroundColor.includes("#") ? this.props.backgroundColor.substring(0, 7) : this.props.backgroundColor,
              marginTop: (this.props.height / 2) - 10
            }}
          />
        }
        <div
          style={{
            width: `calc(100% - ${commandBarWidth}px)`,
            float: "left"
          }}
        >
          {hasCategories &&
            <IAMessageCategories
              categories={this.props.categories}
              paddingLeft={10}
              paddingRight={5}
              paddingTop={5}
              showOverflowCounter
              disablePopup={this.props.isMobile}
              textColorWhenTransparentBackground={this.props.itemTextColor}
              fontSlots={this.props.fontSlots}
            />
          }
          {!this.props.showSkeleton && this.props.showTitle &&
            <div
              className={styles.IA_title}
              style={{
                paddingTop: hasCategories ? 5 : 12,
                fontWeight: this.props.isMessageUnread ? "bold" : "normal",
                fontFamily: this.props.fontSlots?.heading?.fontFamily
              }}
              onClick={() => this.props.onClickOpen()}
            >
              {this.props.title}
            </div>
          }
          {!this.props.showSkeleton && this.props.showTeaser && this.props.teaser != undefined &&
            <div
              className={styles.IA_teaser}
              style={{
                fontFamily: this.props.fontSlots?.body?.fontFamily
              }}
              onClick={() => this.props.onClickOpen()}
            >
              {this.props.teaser}
            </div>
          }
          {(!this.props.showSkeleton && this.props.showAuthor || !this.props.showSkeleton && this.props.showStartDate) &&
            <div
              className={styles.IA_authorAndDate}
              style={{
                fontFamily: this.props.fontSlots?.body?.fontFamily
              }}
              onClick={() => this.props.onClickOpen()}
            >
              {this.props.author != undefined && this.props.showAuthor && this.props.author.displayName != undefined &&
                <div className={styles.IA_author}>{`${this.props.author.displayName} `}</div>
              }
              {this.props.showStartDate &&
                <div style={{ float: "left" }}>
                  <Moment
                    format="L"
                    locale={this.props.userLocation ?? navigator.language}
                  >
                    {this.props.modifiedDate}
                  </Moment>
                </div>
              }
            </div>
          }
        </div>
        {(!this.props.showSkeleton && likesShouldBeShown || !this.props.showSkeleton && commentsShouldBeShown || !this.props.showSkeleton && this.props.showUniqueViews || !this.props.showSkeleton && this.props.showCommandBarItems) &&
          <div
            className={styles.IA_commandBar}
            style={{
              borderColor: `${this.props.itemTextColor}20`
            }}
          >
            {likesShouldBeShown && this.props.id != undefined &&
              <IALikes
                highlightColor={this.props.highlightColor}
                color={this.props.itemTextColor}
                itemId={this.props.id}
                user={this.props.user}
                tenant={this.props.tenant}
                component={this.props.component}
                instance={this.props.instance}
                token={this.props.token}
                environment={this.props.environment}
                source={this.props.source}
                likes={this.props.likes}
                likesUpdated={(likes: ILike[]) => this.props.likesUpdated(likes)}
                displayVertical={true}
                showDimmed={this.props.showLikesDimmed}
                showEmojiPickerExpandButton={this.props.showEmojiPickerExpandButton}
                reactionOptions={this.props.reactionOptions}
                isMobile={this.props.isMobile}
              />
            }
            {commentsShouldBeShown && this.props.id != undefined &&
              <div>
                <IAComments
                  color={this.props.highlightColor}
                  itemId={this.props.id}
                  user={this.props.user}
                  tenant={this.props.tenant}
                  component={this.props.component}
                  instance={this.props.instance}
                  token={this.props.token}
                  environment={this.props.environment}
                  commentCount={this.props.commentCount}
                  commentsUpdated={(comments: number) => this.props.commentsUpdated(comments)}
                  commentsClick={() => this.props.commentsClick()}
                  displayVertical={true}
                  showDimmed={this.props.showCommentsDimmed}
                />
              </div>
            }
            {this.props.showUniqueViews && this.props.id != undefined &&
              <IAUniqueViews
                color={this.props.highlightColor}
                itemId={this.props.id}
                user={this.props.user}
                tenant={this.props.tenant}
                component={this.props.component === "Messages" ? "Message" : "Event"}
                instance={this.props.instance}
                token={this.props.token}
                environment={this.props.environment}
                source={this.props.source}
                uniqueViews={this.props.uniqueViewsCount}
                displayVertical={true}
                showDimmed={this.props.showUniqueViewsDimmed}
              />
            }
            {this.props.showCommandBarItems && this.props.showCommandBarItems &&
              <div className={styles.IA_listElementContainer}
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({ commandaBarOpen: !this.state.commandaBarOpen })
                }}
              >
                <div className={styles.IA_cardBarBtn}>
                  <IAIcon
                    title="Show Action"
                    size={18}
                    color={this.props.highlightColor}
                  /></div>
                {this.state.commandaBarOpen &&
                  <ul
                    className={styles.IA_cardBarItems}
                  >
                    {commandBarItems}
                  </ul>}
              </div>
            }
          </div>
        }
        {this.props.showSkeleton &&
          <div
            className={styles.IA_skeleton}
            style={{
              height: this.props.height
            }}
          >
            <div
              className={styles.IA_skeletonHeadline}
              style={{
                width: "40%",
              }}
            />
            <div
              className={styles.IA_skeletonText}
            />
            <div
              className={styles.IA_skeletonText2}
            />
            <div
              className={styles.IA_skeletonPersonaText}
              style={{
              }}
            />
          </div>
        }
      </div>
    );
  }


}